// extracted by css-extract-rspack-plugin
export default {"cls1":"Carousel-cls1_J7X","cls2":"Carousel-cls2_SAM Carousel-cls1_J7X"};